import useStorage from "./useStorage";

export default function useSessionStorage(key, initialValue) {
  const [storedValue, _setValue] = useStorage(window.sessionStorage, key, initialValue)

  const setValue = (value) => {
    try {
      _setValue(value)
    } catch (e) {
      console.log("ERROR in useSessionStorage.setVaue", key, e)
    }
  };

  return [storedValue, setValue]
}
